import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { ArrowLeft, Upload, Copy, FileText } from 'lucide-react';
import { Button } from '@edusense/shared-ui-kit';
import { LectureEditForm } from '../LectureEditForm';
import toast from 'react-hot-toast';
import * as S from './CurriculumTabContent.styles';
/**
 * 에디터 패널 컴포넌트
 * 
 * 오른쪽에 위치한 강의 편집 패널
 * 강의 선택 시 LectureEditForm 표시, 마크다운 임포트/복사 기능 제공
 */ export const EditorPanel = ({ isFullWidth, curriculumMachineSelectedLesson, selectedLessonData, courseId, onBackToCurriculum, onMarkdownFileImport, onLectureFormDirtyChange })=>{
    console.log('🔍 [EditorPanel] Rendering:', {
        isFullWidth,
        curriculumMachineSelectedLesson,
        selectedLessonData,
        courseId,
        hasSelectedLesson: !!curriculumMachineSelectedLesson,
        lessonId: curriculumMachineSelectedLesson?.lessonId,
        sectionId: curriculumMachineSelectedLesson?.sectionId,
        selectedLessonTitle: selectedLessonData?.title,
        selectedLessonMarkdown: selectedLessonData?.markdown?.substring(0, 100) + '...'
    });
    const fileInputRef = useRef(null);
    // 마크다운 임포트 버튼 클릭 핸들러
    const handleImportClick = ()=>{
        fileInputRef.current?.click();
    };
    // 마크다운 복사 버튼 클릭 핸들러
    const handleCopyClick = ()=>{
        if (selectedLessonData && selectedLessonData.markdown) {
            navigator.clipboard.writeText(selectedLessonData.markdown);
            toast.success('클립보드에 복사되었습니다.');
        } else {
            toast.error('복사할 마크다운 내용이 없습니다.');
        }
    };
    return /*#__PURE__*/ _jsxs(S.EditorPanel, {
        $isFullWidth: isFullWidth,
        children: [
            isFullWidth && /*#__PURE__*/ _jsxs(S.BackToMenuButton, {
                onClick: onBackToCurriculum,
                children: [
                    /*#__PURE__*/ _jsx(ArrowLeft, {
                        size: 16
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        style: {
                            color: '#374151'
                        },
                        children: "커리큘럼으로 돌아가기"
                    })
                ]
            }),
            (()=>{
                console.log('🔍 [EditorPanel] Conditional rendering check:', {
                    hasCurriculumMachineSelectedLesson: !!curriculumMachineSelectedLesson,
                    willRenderLectureEditForm: !!curriculumMachineSelectedLesson,
                    lessonDetails: curriculumMachineSelectedLesson
                });
                return curriculumMachineSelectedLesson;
            })() ? /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    console.log('🔍 [EditorPanel] About to render LectureEditForm with lesson:', curriculumMachineSelectedLesson),
                    /*#__PURE__*/ _jsx("div", {
                        style: {
                            padding: '16px',
                            paddingTop: isFullWidth ? '48px' : '16px'
                        },
                        children: /*#__PURE__*/ _jsxs(S.MarkdownActionButtons, {
                            children: [
                                /*#__PURE__*/ _jsxs(Button, {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: handleImportClick,
                                    children: [
                                        /*#__PURE__*/ _jsx(Upload, {
                                            size: 16
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "마크다운 임포트"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(S.HiddenFileInput, {
                                    type: "file",
                                    ref: fileInputRef,
                                    onChange: onMarkdownFileImport,
                                    accept: ".md,text/markdown"
                                }),
                                /*#__PURE__*/ _jsxs(Button, {
                                    variant: "outline",
                                    size: "sm",
                                    onClick: handleCopyClick,
                                    children: [
                                        /*#__PURE__*/ _jsx(Copy, {
                                            size: 16
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "마크다운 복사"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    console.log('🔍 [EditorPanel] Rendering LectureEditForm now...'),
                    /*#__PURE__*/ _jsx(LectureEditForm, {
                        selectedLesson: curriculumMachineSelectedLesson,
                        courseId: courseId,
                        onDirtyStateChange: onLectureFormDirtyChange
                    }, curriculumMachineSelectedLesson.lessonId)
                ]
            }) : /* 강의 선택 안됨 상태 */ /*#__PURE__*/ _jsxs(S.EmptyEditor, {
                children: [
                    /*#__PURE__*/ _jsx(FileText, {
                        size: 48,
                        style: {
                            marginBottom: '16px',
                            opacity: 0.3
                        }
                    }),
                    /*#__PURE__*/ _jsx("h3", {
                        children: "강의를 선택하세요"
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        children: "왼쪽 패널에서 편집할 강의를 선택하세요."
                    })
                ]
            })
        ]
    });
};
